import { Routes } from '@angular/router';
import { v2On } from '../v2/ui-v2.guard';

export const calendarRoutes: Routes = [
  {
    path: 'calendar',
    canMatch: [v2On],
    loadComponent: () => import('../v2/pages/calendar/calendar-list-v2.page').then(m => m.CalendarListV2Page)
  },
  {
    path: 'calendar',
    loadComponent: () => import('./calendar-list/calendar-list.page').then(m => m.CalendarListPage)
  }
];
